export enum MIME_TYPE {
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
}

export const ACCEPT_FILES = {
  [MIME_TYPE.XLS]: ['.xls'],
  [MIME_TYPE.XLSX]: ['.xlsx'],
  [MIME_TYPE.CSV]: ['.csv'],
};
